import React from 'react';
import {FaTimes} from "react-icons/fa";
import {Types} from "../enums.js";
import VehicleDetails from "../panels/details/vehicle-details.jsx";
import IndividualDetails from "../panels/details/individual-details.jsx";
import EncounterDetails from "../panels/details/encounter-details.jsx";
import BoDetails from "../panels/details/bo-details.jsx";
import OccurrenceDetails from "../panels/details/occurrence-details.jsx";
import SosDetails from "../panels/details/sos-details.jsx";
import CoincidentPassagesDetails from "../panels/details/coincident-passages-details.jsx";
import PassageDetails from "../panels/details/passage-details.jsx";

const bodyColor = {
    individual: "bg-[#f5fff9]",
    encounter: "bg-[#e0f0f6]",
    bo: "bg-[#f5f5f5]",
    occurrence: "bg-[#f5fff9]",
    sos: "bg-[#fffcef]",
    vehicle: "bg-[#eeeeee]",
    passage: "bg-[#ffffff]",
};

const NetworkMarkerInfo = ({node, onClose}) => {
    if (!node) return null;

    return (
        <div className={`absolute top-2 right-2 z-10 w-[300px] max-h-[calc(100%-1rem)] overflow-auto rounded-[5px] shadow-lg
            ${bodyColor[node.type] ?? "bg-white"}`}>
            <div onClick={onClose} title={"Fechar"} className={"flex justify-end p-[10px] cursor-pointer"}>
                <FaTimes color={"#a3a3a3"} size={18}/>
            </div>
            <div>
                {node.type === Types.VEHICLE && <VehicleDetails data={node.data}/>}
                {node.type === Types.INDIVIDUAL && <IndividualDetails data={node.data}/>}
                {node.type === Types.ENCOUNTER && <EncounterDetails data={node.data}/>}
                {node.type === Types.BO && <BoDetails data={node.data}/>}
                {node.type === Types.OCCURRENCE && <OccurrenceDetails data={node.data}/>}
                {node.type === Types.SOS && <SosDetails data={node.data}/>}
                {node.type === Types.COINCIDENT_PASSAGES && <CoincidentPassagesDetails data={node.data}/>}
                {node.type === Types.PASSAGE && <PassageDetails data={node.data}/>}
            </div>
        </div>
    );
};

export default NetworkMarkerInfo;
